import { DefaultLoginToggle } from 'components/DefaultLoginToggle';
import React, { useCallback, useEffect, useState } from 'react';
import { withFirebase } from 'utils/Firebase';

const SocialLoginToggle = ({
  onlyOneLeft,
  isEnabled,
  signInMethod,
  onLink,
  onUnlink,
}) =>
  isEnabled ? (
    <button
      type="button"
			className="rn-button-style--2 mt--20 mr--10"
      onClick={() => onUnlink(signInMethod.id)}
      disabled={onlyOneLeft}
    >
      Deactivate {signInMethod.id}
    </button>
  ) : (
    <button
      type="button"
			className="rn-button-style--2 btn-solid mt--20 mr--10"
      onClick={() => onLink(signInMethod.provider)}
    >
      Link {signInMethod.id}
    </button>
  );

const SIGN_IN_METHODS = [
	{
		id: 'password',
		provider: null,
	},
	{
		id: 'google.com',
		provider: 'googleProvider',
	}
	// {
	// 	id: 'facebook.com',
	// 	provider: 'facebookProvider',
	// }
];

export const LoginManagement = withFirebase((props) => {
	const { firebase, authUser } = props

	const [error, setError] = useState({})
	const [activeSignInMethods, setActiveSignInMethods] = useState([])

	const fetchSignInMethods = useCallback(() => {
		firebase.auth
			.fetchSignInMethodsForEmail(authUser.email)
			.then(methods => setActiveSignInMethods(methods),
			)
			.catch(err => setError(err))
	}, [authUser, firebase.auth])

	const onSocialLoginLink = provider => {
		firebase.auth.currentUser
			.linkWithPopup(firebase[provider])
			.then(fetchSignInMethods)
			.catch(err => setError(err))
	};

	const onUnlink = providerId => {
		firebase.auth.currentUser
			.unlink(firebase[providerId])
			.then(fetchSignInMethods)
			.catch(err => setError(err))
	};

	const onDefaultLoginLink = password => {
		const credential = firebase.emailAuthProvider.credential(
			authUser.email,
			password,
		);

		firebase.auth.currentUser
			.linkWithCredential(credential)
			.then(fetchSignInMethods)
			.catch(err => setError(err));
	};

	useEffect(() => {
		fetchSignInMethods()
	}, [fetchSignInMethods])

	return (
		<div className="mt--20 mr--50 ">
			<h3 className="text-white">Link other Sign In Methods</h3>
			<div className="mb--20">
				{SIGN_IN_METHODS.map(signInMethod => {
					const onlyOneLeft = activeSignInMethods.length === 1;
					const isEnabled = activeSignInMethods.includes(
						signInMethod.id,
					);

					return signInMethod.id === 'password'
								? (
									<div key={signInMethod.id}>
										<DefaultLoginToggle
											onlyOneLeft={onlyOneLeft}
											isEnabled={isEnabled}
											signInMethod={signInMethod}
											onLink={onDefaultLoginLink}
											onUnlink={onUnlink}
										/>
									</div>
							) : (
								<SocialLoginToggle
									key={signInMethod.id}
									onlyOneLeft={onlyOneLeft}
									isEnabled={isEnabled}
									signInMethod={signInMethod}
									onLink={onSocialLoginLink}
									onUnlink={onUnlink}
								/>
							)
				})}
			</div>
			{error && <p className="error">{error.message}</p>}
		</div>
	)
})
